export const meta = {
  id: 'line-segment-intersection',
  name: 'Line Segment Intersection',
  category: 'Geometry',
  complexity: {
    time: 'O(1)',
    space: 'O(1)'
  },
  description: 'Algorithm to detect and compute the intersection point of two line segments in 2D space using orientation tests and cross products.'
};
